import angular from 'angular';

angular
  .module('cloudX')
  .controller('ConfigEditSectionConfigCtrl', [
    'dataCache',
    'resourceFactorySvc',
    'flySvc',
    'close',
    'config',
    'fields',
    ConfigEditSectionConfigCtrl,
  ]);

function ConfigEditSectionConfigCtrl(dataCache, resourceFactorySvc, flySvc, close, config, fields) {
  var vm = this;
  vm.field = fields[config.fieldId];

  vm.config = config;
  var sectionConfig = resourceFactorySvc.get('sectionConfig');

  vm.save = function() {
    sectionConfig.update(
      [vm.config],
      function(response) {
        close(response, 500);
        flySvc.success('Field config modified');
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
  vm.delete = function() {
    sectionConfig.delete(
      {
        id: config.id,
      },
      function(response) {
        config.removed = true;
        close(config, 500);
        flySvc.success('Field config removed');
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
